<template>
  <v-dialog v-model="opened" max-width="480">
    <v-card>
      <v-card-title>Você tem certeza?</v-card-title>
      <v-card-text>
        <slot v-bind="{ data }" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey darken-1" @click="reject()">Não</v-btn>
        <v-btn text color="primary" @click="confirm()">Sim</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Você tem certeza?'
    },
    confirmFn: {
      type: Function,
      default: () => () => null
    },
    rejectFn: {
      type: Function,
      default: () => () => null
    }
  },

  data() {
    return {
      opened: false,
      pending: false,
      data: null
    }
  },
  methods: {
    async confirm() {
      this.pending = true
      await this.confirmFn(this.data)
      this.opened = false
      this.pending = false
    },
    async reject() {
      this.pending = true
      await this.rejectFn(this.data)
      this.opened = false
      this.pending = false
    },
    request(data) {
      this.data = data
      this.opened = true
      this.pending = false
    }
  }
}
</script>
